import Button, { ButtonArrowTypes, ButtonTypes } from "shared/ui/button";
import Card from "shared/ui/card";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";

interface StatusSupportCardProps {
  title: string;
  description: string;
  buttonTitle: string;
  buttonAction: () => void;
  buttonType: ButtonTypes;
}

const StatusSupportCard = ({
  title,
  description,
  buttonTitle,
  buttonAction,
  buttonType,
}: StatusSupportCardProps) => {
  return (
    <Card className="gg-p-7 lg:gg-max-w-sm" shadow={false}>
      <Heading headingLevel="h2" className="gg-mb-2">
        {title}
      </Heading>
      <Text className="gg-text-lg gg-mb-11">{description}</Text>
      <Button
        type={buttonType}
        arrow={ButtonArrowTypes.RIGHT}
        onClick={buttonAction}
        className="gg-font-bold"
      >
        {buttonTitle}
      </Button>
    </Card>
  );
};
export default StatusSupportCard;
